import { apiRequest } from '../../lib/api';
import {
  dataArchiveSummarySchema,
  dataPurgeResultSchema,
  insightStartSchema,
  insightStatusSchema,
} from '../../lib/schemas';
import type { DataArchiveSummary, InsightStatus } from '../../types';

export function getDataArchiveSummary(signal?: AbortSignal): Promise<DataArchiveSummary> {
  return apiRequest('/api/data/summary', dataArchiveSummarySchema, signal ? { signal } : {});
}

export function getInsightStatus(eventId: number, signal?: AbortSignal): Promise<InsightStatus> {
  return apiRequest(`/api/data/report/${eventId}`, insightStatusSchema, signal ? { signal } : {});
}

export function startInsightReport(eventId: number, refresh: boolean): Promise<{ status: 'building' | 'ready' }> {
  const suffix = refresh ? '?refresh=1' : '';
  return apiRequest(`/api/data/report/${eventId}${suffix}`, insightStartSchema, { method: 'POST' });
}

export function purgeArchivedDataset(eventId: number): Promise<{ id: number; purged: 1; removed_messages: number }> {
  return apiRequest(`/api/data/events/${eventId}/purge`, dataPurgeResultSchema, { method: 'POST' });
}
